<template>
  <div v-if="isVisible" class="overlay">
    <div class="spinner"></div>
  </div>
</template>

<script lang="ts" setup>
import { overlaySpinnerService } from '@/services/app/overlay-spinner-service';
import { onMounted, onUnmounted, ref } from 'vue';

const isVisible = ref(false);

const updateVisibility = (visible: boolean) => {
  isVisible.value = visible;
};

onMounted(() => {
  overlaySpinnerService.register(updateVisibility);
});

onUnmounted(() => {
  overlaySpinnerService.unregister();
});
</script>

<style lang="scss" scoped>
@use '@/assets/style/variables';
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(35, 45, 77, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}

.spinner:before {
  content: '';
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 5rem;
  height: 5rem;
  margin-top: -2.5rem;
  margin-left: -2.5rem;
  border-radius: 50%;
  border-top: 0.5rem solid var(--primary-color);
  border-right: 0.5rem solid transparent;
  animation: spinner 0.6s linear infinite;
}
</style>
